import { delay } from 'redux-saga'
import {all, call, fork, put, takeEvery, select, take, takeLatest} from 'redux-saga/effects';
import {
    REQ_ADD_DATA_GROUP_USER,
    GET_ADD_DATA_GROUP_USER,
    REQ_ALL_COMPANY,
    GET_ALL_COMPANY,
    REQ_POOL_COMPANY,
    GET_POOL_COMPANY,
    REQ_VEHICLE_COMPANY,
    GET_VEHICLE_COMPANY,
    REQ_TRANSIT_COMPANY,
    GET_TRANSIT_COMPANY,
    REQ_SETTING_MENU,
    GET_SETTING_MENU,
    REQ_ALL_GROUP,
    GET_ALL_GROUP,
    REQ_SET_USER_MANAGE,
    GET_SET_USER_MANAGE,
    REQ_ADD_GROUP,
    REQ_EDIT_GROUP,
    REQ_DELETE_GROUP,
    GET_ADD_GROUP,
    GET_EDIT_GROUP,
    GET_DELETE_GROUP,
    REQ_VISITED_PAGE,
    GET_VISITED_PAGE,
    SUCCESS_MESSAGE_MANAGE,
    ERROR_MESSAGE_MANAGE,
    BASE_URL_APIv5,
    BASE_URL_API2,
} from 'constants/ActionTypes';


import axios from 'axios'

const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}

const callAllCompany = async str => {
    const obj = {
        paging : {start : 0, length:-1},
        orders : {columns:["id"], ascending:true},
        columns : [
                ... str !== '' && [{name:"name", "logic_operator":"like", value: str, "operator":"AND"}]
        ]
    }
    let arr = JSON.stringify(obj);
    const result = await axios.post(`${BASE_URL_APIv5}/company/search`, arr, config)
                    .then(res => res)
                    .catch(error => error.response)
    return result

}

const callPoolCompany = async (url) => {
    return await axios.get(url)
                    .then(res => res)
                    .catch(error => error.response)
}

const callAllVehicle =  async (company, str) => {
    
    let string = company.map(i => `${i}`).join(',');
    
    const obj = {
        paging  : {"length":-1},
        joins : [
            {name:"company",column_results:["name"]}
        ],
        columns : [
                ... str !== '' && [{name:"license_plate", "logic_operator":"like", value: str, "operator":"AND"}],
                {name:"company_id",logic_operator:"in",value:`${string}`, value1:"","operator":"AND"}
        ]
    }
    let arr = JSON.stringify(obj); 
    const result = await axios.post(`${BASE_URL_APIv5}/vehicle/search-vehicle`, arr, config)
                    .then(res => res)
                    .catch(error => error.response)
                    
    return result
}

const callTransitCompany =  async (url) => {
    return await axios.get(url)
                    .then(res => res)
                    .catch(error => error.response)
}


const callAllGroup = async () => {
    const token1 = localStorage.getItem('apiKey')
    const config1 = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token1}`
        }
    }
    // console.log('--access role--')
    const roleUser = localStorage.getItem('rolename')
    let dataConfig = {
        paging : {start : 0, length:20},
        orders : {columns:["role_name"],ascending:false},
        columns : [
            {name:"role_parent","logic_operator":"=",value:roleUser,"operator":"OR"},
            {name:"role_name","logic_operator":"=",value:roleUser,"operator":"OR"}
        ]
    }
    let obj = JSON.stringify(dataConfig)
    const result = await axios.post(`${BASE_URL_APIv5}/master-role/search`, obj, config1)
                        .then(res => res)
                        .catch((error) => error.response)
    return result
}

const callSetAllUserPackage = async (data) => {
    let obj = JSON.stringify(data)
    return await axios.post(`${BASE_URL_API2}/oslog/api/elasticsearch/user_management/cmd/post-data?apiKey=c4ca4238-a0b9-2382-0dcc-509a6f75849b`, obj)
                    .then(res => res)
                    .catch(error => error.response)
}

const callAddGroup = async (name, namePackage) => {
    const parent = localStorage.getItem('rolename')
    const token1 = localStorage.getItem('apiKey')
    const config1 = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token1}`
        }
    }

    const data = {role_name: name, package_name: namePackage, role_parent: parent}

    let obj = JSON.stringify(data)
    
    return await axios.post(`${BASE_URL_APIv5}/master-role/new`, obj, config1)
                    .then(res => res)
                    .catch(error => error.response)
}

const callEditGroup = async (result) => {
    const {id, name, namePackage} = result

    const data = {role_name: name, package_name: namePackage}

    let obj = JSON.stringify(data)
    
    return await axios.put(`${BASE_URL_APIv5}/master-role/edit/${id}`, obj, config)
                    .then(res => res)
                    .catch(error => error.response)
}

const callDeleteGroup = async (id) => {
    
    return await axios.delete(`${BASE_URL_APIv5}/master-role/delete/${id}`, config)
                    .then(res => res)
                    .catch(error => error.response)
}







// Set Function
export function* setDataAddgroupUser(data) {
    try {
        yield put({type: GET_ADD_DATA_GROUP_USER, payload: data.action});
    } catch (error) {
        // console.log(error)
    }
    
}

export function* setAllCompany(data){
    try {
        const result = yield call(callAllCompany, data.action)

        if(result.data.status === true){
            const data = result.data.data
            yield put({type: GET_ALL_COMPANY, payload: data})
        } else {
            
        }
    } catch (error) {
        // console.log('get company fail')
    }
}

export function* setPoolCompany(data){
    const aa = data.action
    const url = []
    const arr = []
    

    try {
        if(aa.length > 0 || aa !== undefined) {
            // console.log('has Pool data')
            aa.map(res => {
                const api = `${BASE_URL_API2}/oslog/api/pool/cmd/get-name?apiKey=a4a042cf-4fd6-bfb4-7701-cbc8a1653ada&params={%22company%22:%22${res.id}%22}`;
                url.push({id: res.id, name: res.name, url: api})
            })
        
            // console.log(url)
            yield*url.map(function* (res) {
                const result = yield call(callPoolCompany, res.url)
                arr.push({company_id: res.id, name: res.name, data: result.data})
            })
            // console.log(arr)
            yield put({type: GET_POOL_COMPANY, payload: arr})
        } else {
            // console.log('no company data')
            yield put({type: GET_POOL_COMPANY, payload: []})
        }
    } catch (error) {
        // console.log('get pool fail')
    }
}

export function* setVehicleCompany({action}){
    // console.log('---vehicle---')
    const {company, str} = action
    if(company !== undefined){
        try {
            // console.log('set vehicle')
            const result = yield call(callAllVehicle, company, str)
            // console.log(result)
           if(result.data.status === true){
                const data = result.data.data
                yield put({type: GET_VEHICLE_COMPANY, payload: data})
           }
        } catch (error) {
            const string = 'Oops! looks like something wrong'
            yield put({type: ERROR_MESSAGE_MANAGE, payload: string})
        }
    }
}

export function* setTransitCompany(data){
    const aa = data.action
    const url = []
    const arr = []
    

    try {
        if(aa.length > 0 || aa !== undefined) {
            // console.log('has Transit data')
            aa.map(res => {
                const api = `${BASE_URL_API2}/oslog/api/transit-point/cmd/get-name?apiKey=a4a042cf-4fd6-bfb4-7701-cbc8a1653ada&params={%22company%22:%22${res.id}%22}`;
                url.push({id: res.id, name: res.name, url: api})
            })
        
            // console.log(url)
            yield*url.map(function* (res) {
                const result = yield call(callTransitCompany, res.url)
                arr.push({company_id: res.id, name: res.name, data: result.data})
            })
            // console.log(arr)
            yield put({type: GET_TRANSIT_COMPANY, payload: arr})
        } else {
            // console.log('no company data')
            yield put({type: GET_TRANSIT_COMPANY, payload: []})
        }
    } catch (error) {
        // console.log('get pool fail')
    }
}

export function* getAllGroup (){
    const arr = []
    try {
        const result = yield call(callAllGroup)
        if (result.data.status ===  true){
            const data = result.data.data
            yield put({type: GET_ALL_GROUP, payload: data})
        } else {
            yield put({type: ERROR_MESSAGE_MANAGE, payload: result.data.message})
        }
        
    } catch (error) {
        const string = 'Oops! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MANAGE, payload: string})
    }
}

export function* getSetUserManage (data) {
    try {
        // console.log(`id from delete saga is ${data.action}`)
        const result = yield call(callSetAllUserPackage, data.action)
        // console.log(result)
        // yield put({type: GET_DELETE_PACKAGE, payload: data.action})
    } catch (error) {
        // console.log(error)
    }
}

export function* getAddGroup (data) {
    if(data.action !== undefined) {
        try {
            // console.log('add group saga')
            // console.log(data.action)
            const {textFieldGroup, textFieldPackage} = data.action
            const result = yield call(callAddGroup, textFieldGroup, textFieldPackage)
            // console.log(result)
            if (result.data.status === true){
                const role = result.data.data
                const success = 'Data Successfuly Created'
                yield put({type: SUCCESS_MESSAGE_MANAGE, payload: success})
                yield put({type: GET_ADD_GROUP, payload: role})
            } else {
                yield put({type: ERROR_MESSAGE_MANAGE, payload: result.data.message})
            }
        } catch (error) {
            const error = 'Opps! looks like something wrong'
            yield put({type: ERROR_MESSAGE_MANAGE, payload: error})
        }
    }
}

export function* getEditGroup (data) {
    try {
        // console.log('edit group saga')
        // console.log(data.action)
        const result = yield call(callEditGroup, data.action)
        // console.log(result)
        if (result.data.status === true){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_MANAGE, payload: success})
        } else {
            yield put({type: ERROR_MESSAGE_MANAGE, payload: result.data.message})
        }
        
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MANAGE, payload: error})
    }
}

export function* getDeleteGroup (data) {
    try {
        // console.log(`id group from delete saga is ${data.action}`)
        const result = yield call(callDeleteGroup, data.action)
        // console.log(result)
        if (result.status === 200){
            const success = 'Data Successfuly Deleted'
            yield put({type: SUCCESS_MESSAGE_MANAGE, payload: success})
        } else {
            yield put({type: ERROR_MESSAGE_MANAGE, payload: result.data.message})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MANAGE, payload: error})
    }
}

export function* getVisistedPage (data) {
    try {
        const a = yield select(state => state.userManage)
        const dataVisited = JSON.parse(JSON.stringify(a.visitedPage));

        if(data.action === 'user_management'){
            // console.log('this is user management')
            let b = dataVisited.user_management
            const obj = {...dataVisited, user_management: b + 1}
            // console.log(obj)
            yield put({type: GET_VISITED_PAGE, payload: obj})
        } else if (data.action === 'packages_menu'){
            // console.log('this is packages menu')
            let b = dataVisited.packages_menu
            const obj = {...dataVisited, packages_menu: b + 1}
            // console.log(obj)
            yield put({type: GET_VISITED_PAGE, payload: obj})
        }

    } catch (error) {
        console
    }
}


export function* reqDataAddGroupUser() {
    yield takeEvery(REQ_ADD_DATA_GROUP_USER, setDataAddgroupUser);
}

export function* reqAllCompany(){
    yield takeEvery(REQ_ALL_COMPANY, setAllCompany)
}

export function* reqPoolCompany(){
    yield takeEvery(REQ_POOL_COMPANY, setPoolCompany)
}

export function* reqVehicleCompany(){
    yield takeEvery(REQ_VEHICLE_COMPANY, setVehicleCompany)
}

export function* reqTransitCompany(){
    yield takeEvery(REQ_TRANSIT_COMPANY, setTransitCompany)
}

export function* reqAllGroup(){
    yield takeEvery(REQ_ALL_GROUP, getAllGroup)
}

export function* reqSetUserManage(){
    yield takeEvery(REQ_SET_USER_MANAGE, getSetUserManage)
}

export function* reqAddGroup(){
    yield takeEvery(REQ_ADD_GROUP, getAddGroup)
}

export function* reqEditGroup(){
    yield takeEvery(REQ_EDIT_GROUP, getEditGroup)
}

export function* reqDeleteGroup(){
    yield takeEvery(REQ_DELETE_GROUP, getDeleteGroup)
}

export function* reqVisitedPage(){
    yield takeEvery(REQ_VISITED_PAGE, getVisistedPage)
}


export default function* rootSaga() {
    yield all([
        fork(reqDataAddGroupUser),
        fork(reqAllCompany),
        fork(reqPoolCompany),
        fork(reqVehicleCompany),
        fork(reqTransitCompany),
        fork(reqAllGroup),
        fork(reqSetUserManage),
        fork(reqAddGroup),
        fork(reqEditGroup),
        fork(reqDeleteGroup),
        fork(reqVisitedPage),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/UserManage.js